import { Component, Input, OnInit } from '@angular/core';
import { Media } from 'src/app/generales/login/pages/perfil/interfaces-perfil/interfacesPerfil';
import { StorageService } from 'src/app/generales/services/storage.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-product-mostrario',
  templateUrl: './product-mostrario.component.html',
  styleUrls: ['./product-mostrario.component.scss'],
})
export class ProductMostrarioComponent implements OnInit {
  @Input() media;
  url: string = environment.url;
  imagenes: string[] = [];
  selectedImg: string = '';

  constructor() {}

  async ngOnInit() {
    const media = this.media;
    this.selectedImg = `${this.url}/file/${media[0].img}`;
    media.forEach((image) => {
      const urlImage = `${this.url}/file/${image.img}`;
      this.imagenes.push(urlImage);
    });
  }

  changeImg(src) {
    this.selectedImg = src;
  }
}
